import { MdOutlineError } from 'react-icons/md';
import { AircraftIcon } from '@icons';

export const CommercialLegInfo = ({ bookingNumber }: { bookingNumber?: string }) => {
  const hasBookingNumber = !!bookingNumber;

  return !hasBookingNumber ? (
    <div className="w-max flex px-1 py-0.5 rounded-[4px] gap-1 bg-base-70">
      <div className="text-danger-30">
        <MdOutlineError size={16} />
      </div>
      <AircraftIcon />
      <span className="text-s-r text-base-10">Booking Number is missing</span>
    </div>
  ) : null;
};
